import { render, staticRenderFns } from "./RegisterVerifyForm.vue?vue&type=template&id=72dc6900&scoped=true&"
import script from "./RegisterVerifyForm.vue?vue&type=script&lang=js&"
export * from "./RegisterVerifyForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterVerifyForm.vue?vue&type=style&index=0&id=72dc6900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc6900",
  null
  
)

export default component.exports